/**
 * Agent task / run model (UI + future GET /agents/:id/runs).
 *
 * run_kind:
 * - live: real execution after agent is started (counts toward plan quota).
 * - preview: Preview Agent modal / preview_execute (does NOT count toward quota).
 * - manual_test: ad-hoc “Run now” / debug from UI (does NOT count toward quota).
 * - sandbox: simulated / demo rows.
 */

export const RUN_KINDS = {
  LIVE: "live",
  PREVIEW: "preview",
  MANUAL_TEST: "manual_test",
  SANDBOX: "sandbox",
};

/** Terminal / in-progress run statuses stored on agent_tasks.status */
export const RUN_STATUSES = {
  RUNNING: "running",
  SUCCESS: "success",
  PARTIAL_SUCCESS: "partial_success",
  /** Intentional stop: goal/criteria said do not proceed (not a system failure). */
  SKIPPED: "skipped",
  /**
   * No-progress circuit breaker: stuck reasoning / re-fetch / nudge loop.
   * Distinct from error so the team can filter and analyze these runs.
   */
  HALTED: "halted",
  ERROR: "error",
  CANCELLED: "cancelled",
};

/** Steps shown in task detail pane (chronological). */
export const RUN_STEP_PHASES = {
  TRIGGER: "trigger",
  REASONING: "reasoning",
  TOOL_CALL: "tool_call",
  OUTCOME: "outcome",
  ERROR: "error",
};
